import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_AVG_CASE_DURATION_QUERY_KEY } from "../types/CommonTypes";
import { GET_AVG_CASE_DURATION_RESPONSE } from "../types/ResponseTypes";

async function getAvgCaseDuration(tenantId: string, hospitalId: string, queryString: string): Promise<GET_AVG_CASE_DURATION_RESPONSE> {
  const baseUrl = "analytics/average-case-duration";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  
  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data?.otData || [];
}

export default function useGetAvgCaseDurationQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_AVG_CASE_DURATION_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getAvgCaseDuration(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 